import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { ConfigurationsActionTypes } from "../actions/actionTypes";
import { configurationsAPI } from "../api/api";

function* getConfigurationsList(action) {
    try {
        const halls = yield call(() =>
            configurationsAPI.getHalls({
                page: action.payload.page,
                search: action.payload.search
            })
        );

        const configs = yield call(configurationsAPI.getConfigurationsList);

        yield put({
            type: ConfigurationsActionTypes.GET_CONFIGURATIONS_LIST_SUCCESS,
            payload: {
                halls: halls.data,
                configs: configs.data
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting configurations list.");

        yield put({
            type: ConfigurationsActionTypes.GET_CONFIGURATIONS_LIST_FAIL,
            message: e.message
        });
    }
}

export function* getConfigurationsListWatcher() {
    yield takeLatest(
        ConfigurationsActionTypes.GET_CONFIGURATIONS_LIST,
        getConfigurationsList
    );
}
